import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2105d81a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "calendar-events-container" }
const _hoisted_2 = { class: "header-actions" }
const _hoisted_3 = { class: "action-buttons" }
const _hoisted_4 = { class: "view-toggle" }
const _hoisted_5 = { class: "calendar-header" }
const _hoisted_6 = { class: "filters" }
const _hoisted_7 = { class: "filter-row" }
const _hoisted_8 = { class: "filter-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "eventType" }, "Event Type:", -1))
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<option value=\"\" data-v-2105d81a>All Types</option><option value=\"regular\" data-v-2105d81a>Regular</option><option value=\"closed\" data-v-2105d81a>Closed</option><option value=\"snow_day\" data-v-2105d81a>Snow Day</option><option value=\"early_dismissal\" data-v-2105d81a>Early Dismissal</option><option value=\"late_start\" data-v-2105d81a>Late Start</option><option value=\"sick_day\" data-v-2105d81a>Sick Day</option><option value=\"holiday\" data-v-2105d81a>Holiday</option><option value=\"bell_schedule\" data-v-2105d81a>Bell Schedule</option><option value=\"other\" data-v-2105d81a>Other</option>", 10)
const _hoisted_20 = [
  _hoisted_10
]
const _hoisted_21 = { class: "filter-group" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "startDate" }, "Start Date:", -1))
const _hoisted_23 = ["max"]
const _hoisted_24 = { class: "filter-group" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "endDate" }, "End Date:", -1))
const _hoisted_26 = ["min"]
const _hoisted_27 = { class: "filter-actions" }
const _hoisted_28 = {
  key: 0,
  class: "loading"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Loading events...", -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  key: 1,
  class: "error-message"
}
const _hoisted_32 = {
  key: 2,
  class: "calendar-grid"
}
const _hoisted_33 = { class: "calendar-nav" }
const _hoisted_34 = { class: "nav-controls" }
const _hoisted_35 = { class: "month-year-selector" }
const _hoisted_36 = ["value"]
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "calendar-weekdays" }
const _hoisted_39 = { class: "calendar-days" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "day-number" }
const _hoisted_42 = {
  key: 0,
  class: "day-events"
}
const _hoisted_43 = {
  key: 0,
  class: "school-closed-text"
}
const _hoisted_44 = {
  key: 1,
  class: "early-release-text"
}
const _hoisted_45 = {
  key: 0,
  class: "more-events"
}
const _hoisted_46 = {
  key: 3,
  class: "events-list"
}
const _hoisted_47 = /*#__PURE__*/_createStaticVNode("<div class=\"list-header\" data-v-2105d81a><div class=\"list-column title\" data-v-2105d81a>Title</div><div class=\"list-column type\" data-v-2105d81a>Type</div><div class=\"list-column grades\" data-v-2105d81a>Grades</div><div class=\"list-column date\" data-v-2105d81a>Date</div><div class=\"list-column actions\" data-v-2105d81a>Actions</div></div>", 1)
const _hoisted_48 = { class: "list-content" }
const _hoisted_49 = { class: "list-column title" }
const _hoisted_50 = { class: "list-column type" }
const _hoisted_51 = { class: "list-column grades" }
const _hoisted_52 = { class: "list-column date" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { class: "list-column actions" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = {
  key: 4,
  class: "modal-overlay"
}
const _hoisted_58 = { class: "modal-content" }
const _hoisted_59 = { class: "modal-header" }
const _hoisted_60 = {
  key: 0,
  class: "event-details"
}
const _hoisted_61 = { class: "event-date" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = {
  key: 0,
  class: "event-description"
}
const _hoisted_64 = {
  key: 1,
  class: "grade-ranges-display"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Grade Levels:", -1))
const _hoisted_66 = { class: "grade-tags" }
const _hoisted_67 = {
  key: 1,
  class: "event-form"
}
const _hoisted_68 = { class: "form-group" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Event Title *", -1))
const _hoisted_70 = { class: "form-group" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "type" }, "Event Type *", -1))
const _hoisted_72 = /*#__PURE__*/_createStaticVNode("<option value=\"\" data-v-2105d81a>Select Event Type</option><option value=\"regular\" data-v-2105d81a>Regular</option><option value=\"closed\" data-v-2105d81a>Closed</option><option value=\"snow_day\" data-v-2105d81a>Snow Day</option><option value=\"early_dismissal\" data-v-2105d81a>Early Dismissal</option><option value=\"late_start\" data-v-2105d81a>Late Start</option><option value=\"sick_day\" data-v-2105d81a>Sick Day</option><option value=\"holiday\" data-v-2105d81a>Holiday</option><option value=\"bell_schedule\" data-v-2105d81a>Bell Schedule</option><option value=\"other\" data-v-2105d81a>Other</option>", 10)
const _hoisted_82 = [
  _hoisted_72
]
const _hoisted_83 = { class: "form-group" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Description", -1))
const _hoisted_85 = { class: "form-row" }
const _hoisted_86 = { class: "form-group" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "startDate" }, "Start Date *", -1))
const _hoisted_88 = ["min", "max"]
const _hoisted_89 = { class: "form-group" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "endDate" }, "End Date", -1))
const _hoisted_91 = ["min", "max"]
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Leave blank for single-day events", -1))
const _hoisted_93 = { class: "form-row" }
const _hoisted_94 = { class: "form-group" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "startTime" }, "Start Time (Optional)", -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Leave empty to use calendar's default start time", -1))
const _hoisted_97 = { class: "form-group" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "endTime" }, "End Time (Optional)", -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Leave empty to use calendar's default end time", -1))
const _hoisted_100 = { class: "modal-actions" }
const _hoisted_101 = ["disabled"]
const _hoisted_102 = { key: 0 }
const _hoisted_103 = { key: 1 }
const _hoisted_104 = {
  key: 5,
  class: "modal-overlay"
}
const _hoisted_105 = { class: "modal-content" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Confirm Delete", -1))
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "warning" }, "This action cannot be undone.", -1))
const _hoisted_108 = { class: "modal-actions" }
const _hoisted_109 = {
  key: 6,
  class: "modal-overlay"
}
const _hoisted_110 = { class: "modal-content" }
const _hoisted_111 = { class: "modal-header" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Import Events", -1))

import { ref, computed, onMounted, watch, reactive } from "vue";
import { useRouter, useRoute } from "vue-router";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowLeft,
  faPlus,
  faFilter,
  faUndo,
  faChevronLeft,
  faChevronRight,
  faCalendarDay,
  faTimes,
  faEdit,
  faTrash,
  faFileImport,
  faList,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { API_URL } from "../config";
import ImportICSEvents from "../components/ImportICSEvents.vue";
import { getErrorMessage } from "../types";
import type { CalendarDayCell, CalendarEventRecord } from "../types";

type CalendarEvent = CalendarEventRecord;

// Register Font Awesome icons
interface EventData {
  title: string;
  type: string;
  description?: string;
  startDate: string;
  endDate?: string;
  startTime?: string;
  endTime?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarEventsView',
  setup(__props) {

library.add(
  faArrowLeft,
  faPlus,
  faFilter,
  faUndo,
  faChevronLeft,
  faChevronRight,
  faCalendarDay,
  faTimes,
  faEdit,
  faTrash,
  faFileImport,
  faList
);

// Router and Route
const router = useRouter();
const route = useRoute();
const calendarId = route.params.calendarId as string;

// State
const events = ref<CalendarEvent[]>([]);
const calendarName = ref("");
const loading = ref(false);
const error = ref("");
const showDeleteModal = ref(false);
const eventToDelete = ref<CalendarEvent | null>(null);
const showEventModal = ref(false);
const selectedDate = ref<Date | null>(null);
const selectedEvent = ref<CalendarEvent | null>(null);
const currentDate = ref(new Date());

// Filters
const filters = reactive({
  type: "",
  startDate: "",
  endDate: "",
});

// Add these new refs and computed properties after the existing state declarations
const selectedMonth = ref(new Date().getMonth());
const selectedYear = ref(new Date().getFullYear());

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const yearRange = computed(() => {
  const currentYear = new Date().getFullYear();
  const years = [];
  // Show 5 years before and after the current year
  for (let i = currentYear - 5; i <= currentYear + 5; i++) {
    years.push(i);
  }
  return years;
});

const weekDays = computed(() => {
  return ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
});

const calendarDays = computed(() => {
  const year = currentDate.value.getFullYear();
  const month = currentDate.value.getMonth();
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  const days = [];

  // Add days from previous month
  const firstDayWeekday = firstDay.getDay();
  for (let i = firstDayWeekday - 1; i >= 0; i--) {
    const date = new Date(year, month, -i);
    days.push({
      date,
      dayNumber: date.getDate(),
      isCurrentMonth: false,
      events: getEventsForDate(date),
    });
  }

  // Add days from current month
  for (let i = 1; i <= lastDay.getDate(); i++) {
    const date = new Date(year, month, i);
    days.push({
      date,
      dayNumber: i,
      isCurrentMonth: true,
      events: getEventsForDate(date),
    });
  }

  // Add days from next month
  const remainingDays = 42 - days.length;
  for (let i = 1; i <= remainingDays; i++) {
    const date = new Date(year, month + 1, i);
    days.push({
      date,
      dayNumber: date.getDate(),
      isCurrentMonth: false,
      events: getEventsForDate(date),
    });
  }

  return days;
});

// Methods
const normalizeDate = (date: Date): Date => {
  // Create a new date object with just the date part (no time)
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

const getEventsForDate = (date: Date) => {
  if (!events.value || !Array.isArray(events.value)) {
    return [];
  }

  // Get date string in YYYY-MM-DD format
  const compareDateStr = date.toISOString().split("T")[0];

  return events.value.filter((event) => {
    const eventStartStr = event.startDate.split("T")[0];
    const eventEndStr = event.endDate
      ? event.endDate.split("T")[0]
      : eventStartStr;

    return compareDateStr >= eventStartStr && compareDateStr <= eventEndStr;
  });
};

const isToday = (date: Date) => {
  const today = normalizeDate(new Date());
  const normalizedDate = normalizeDate(date);
  return normalizedDate.getTime() === today.getTime();
};

const previousMonth = () => {
  if (selectedMonth.value === 0) {
    selectedMonth.value = 11;
    selectedYear.value--;
  } else {
    selectedMonth.value--;
  }
  currentDate.value = new Date(selectedYear.value, selectedMonth.value);
};

const nextMonth = () => {
  if (selectedMonth.value === 11) {
    selectedMonth.value = 0;
    selectedYear.value++;
  } else {
    selectedMonth.value++;
  }
  currentDate.value = new Date(selectedYear.value, selectedMonth.value);
};

const handleDayClick = (day: CalendarDayCell) => {
  selectedDate.value = day.date;
  selectedEvent.value = day.events[0] || null;

  // Set the start date and end date to the selected date
  if (!selectedEvent.value) {
    newEvent.startDate = day.date.toISOString().split("T")[0];
    newEvent.endDate = day.date.toISOString().split("T")[0];
  }

  showEventModal.value = true;
};

const closeEventModal = () => {
  showEventModal.value = false;
  selectedDate.value = null;
  selectedEvent.value = null;
};

// Add new state for the event form
const newEvent = reactive({
  title: "",
  type: "",
  description: "",
  startDate: "",
  endDate: "",
  startTime: "",
  endTime: "",
});

// Add type for event data
const calendarStartDate = ref("");
const calendarEndDate = ref("");
const isSubmitting = ref(false);

// Update the submitNewEvent method to handle default times
const submitNewEvent = async () => {
  // Validate form
  if (!newEvent.title) {
    error.value = "Please enter an event title";
    return;
  }

  if (!newEvent.type) {
    error.value = "Please select an event type";
    return;
  }

  if (!newEvent.startDate) {
    error.value = "Please select a start date";
    return;
  }

  // Validate dates are within calendar range
  const startDate = new Date(newEvent.startDate);
  const endDate = newEvent.endDate ? new Date(newEvent.endDate) : startDate;
  const calendarStart = new Date(calendarStartDate.value);
  const calendarEnd = new Date(calendarEndDate.value);

  if (startDate < calendarStart || startDate > calendarEnd) {
    error.value = "Start date must be within the calendar's date range";
    return;
  }

  if (endDate < startDate) {
    error.value = "End date cannot be before start date";
    return;
  }

  if (endDate > calendarEnd) {
    error.value = "End date must be within the calendar's date range";
    return;
  }

  // Prepare event data, only including times if they are different from defaults
  const eventData: EventData = {
    title: newEvent.title,
    type: newEvent.type,
    startDate: newEvent.startDate,
  };

  // Add optional fields only if they have values
  if (newEvent.description) eventData.description = newEvent.description;
  if (newEvent.endDate) eventData.endDate = newEvent.endDate;

  // Only include times if they are different from defaults
  if (
    newEvent.startTime &&
    newEvent.startTime !== calendarDefaultStartTime.value
  ) {
    eventData.startTime = newEvent.startTime;
  }
  if (newEvent.endTime && newEvent.endTime !== calendarDefaultEndTime.value) {
    eventData.endTime = newEvent.endTime;
  }

  isSubmitting.value = true;
  try {
    await axios.post(`${API_URL}/calendar/${calendarId}/events`, eventData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    // Refresh events
    await fetchCalendar();

    // Close modal
    closeEventModal();
  } catch (err: unknown) {
    error.value = getErrorMessage(err, "Failed to create event");
    console.error("Error creating event:", err);
  } finally {
    isSubmitting.value = false;
  }
};

const editEvent = (event: CalendarEvent) => {
  router.push(`/calendar/${calendarId}/events/${event.id}/edit`);
};

const confirmDelete = (event: CalendarEvent) => {
  eventToDelete.value = event;
  showDeleteModal.value = true;
};

// Initialize date filters with calendar start/end dates
const initializeDateFilters = (startDate: string, endDate: string) => {
  // Default to current month if no dates provided
  if (!startDate || !endDate) {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    filters.startDate = firstDay.toISOString().split("T")[0];
    filters.endDate = lastDay.toISOString().split("T")[0];
  } else {
    filters.startDate = startDate;
    filters.endDate = endDate;
  }
};

// Format functions
const formatDate = (dateString: string): string => {
  if (!dateString) return "N/A";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "Invalid Date";

  // Adjust for timezone offset
  const userTimezoneOffset = date.getTimezoneOffset() * 60000;
  const adjustedDate = new Date(date.getTime() + userTimezoneOffset);

  return adjustedDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

const formatEventType = (type: string): string => {
  if (!type) return "";

  return type
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

// Functions
const fetchCalendar = async () => {
  loading.value = true;
  error.value = "";
  try {
    console.log("Fetching calendar and events:", calendarId);
    const response = await axios.get(`${API_URL}/calendar/${calendarId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    console.log("Calendar API Response:", response.data);

    // Set calendar data
    calendarName.value = response.data.name;
    calendarStartDate.value = response.data.startDate;
    calendarEndDate.value = response.data.endDate;
    calendarDefaultStartTime.value = response.data.defaultStartTime || "";
    calendarDefaultEndTime.value = response.data.defaultEndTime || "";

    // Set events data
    events.value = response.data.events || [];
    console.log("Updated events.value:", events.value);

    // Initialize date filters with calendar start/end dates
    initializeDateFilters(response.data.startDate, response.data.endDate);
  } catch (err: unknown) {
    error.value = getErrorMessage(err, "Failed to fetch calendar");
    console.error("Error fetching calendar:", err);
    events.value = []; // Reset to empty array on error
  } finally {
    loading.value = false;
  }
};

const navigateToAddEvent = () => {
  router.push(`/calendar/${calendarId}/events/add`);
};

const goBack = () => {
  router.push(`/calendar/${calendarId}`);
};

const applyFilters = () => {
  fetchCalendar();
};

const resetFilters = () => {
  filters.type = "";
  // Reset date filters to calendar start/end dates or current month
  fetchCalendar();
};

const deleteEvent = async () => {
  if (!eventToDelete.value) return;

  try {
    await axios.delete(
      `${API_URL}/calendar/${calendarId}/events/${eventToDelete.value.id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    await fetchCalendar();
    showDeleteModal.value = false;
    eventToDelete.value = null;
  } catch (err: unknown) {
    error.value = getErrorMessage(err, "Error deleting event");
  }
};

// Add these new methods after the existing methods
const handleMonthChange = () => {
  currentDate.value = new Date(selectedYear.value, selectedMonth.value);
};

const handleYearChange = () => {
  currentDate.value = new Date(selectedYear.value, selectedMonth.value);
};

const goToToday = () => {
  const today = new Date();
  selectedMonth.value = today.getMonth();
  selectedYear.value = today.getFullYear();
  currentDate.value = today;
};

// Add a watch to sync the selectedMonth and selectedYear with currentDate
watch(currentDate, (newDate) => {
  selectedMonth.value = newDate.getMonth();
  selectedYear.value = newDate.getFullYear();
});

// Add new refs for default times
const calendarDefaultStartTime = ref("");
const calendarDefaultEndTime = ref("");

// Add new state for import modal
const showImportModal = ref(false);

// Add new ref for view mode
const viewMode = ref<"calendar" | "list">("calendar");

// Add computed property for filtered events
const filteredEvents = computed(() => {
  let filtered = [...events.value];

  // Apply type filter
  if (filters.type) {
    filtered = filtered.filter((event) => event.type === filters.type);
  }

  // Apply date range filter
  if (filters.startDate && filters.endDate) {
    const startDate = new Date(filters.startDate);
    const endDate = new Date(filters.endDate);
    filtered = filtered.filter((event) => {
      const eventDate = new Date(event.startDate);
      return eventDate >= startDate && eventDate <= endDate;
    });
  }

  // Sort by date
  return filtered.sort(
    (a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
  );
});

// Update the formatGradeRange function to handle null values
const formatGradeRange = (range: string | null): string => {
  if (!range) return "All Grades";

  switch (range) {
    case "all_grades":
      return "All Grades";
    case "elementary":
      return "Elementary";
    case "middle":
      return "Middle";
    case "high":
      return "High";
    default:
      return range;
  }
};

// Lifecycle hooks
onMounted(() => {
  fetchCalendar();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn-back",
        onClick: goBack
      }, [
        _createVNode(_unref(FontAwesomeIcon), { icon: "arrow-left" }),
        _createTextVNode(" Back to Calendar ")
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: _normalizeClass(["btn-toggle", { active: viewMode.value === 'calendar' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (viewMode.value = 'calendar'))
          }, [
            _createVNode(_unref(FontAwesomeIcon), { icon: "calendar" }),
            _createTextVNode(" Calendar ")
          ], 2),
          _createElementVNode("button", {
            class: _normalizeClass(["btn-toggle", { active: viewMode.value === 'list' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (viewMode.value = 'list'))
          }, [
            _createVNode(_unref(FontAwesomeIcon), { icon: "list" }),
            _createTextVNode(" List ")
          ], 2)
        ]),
        _createElementVNode("button", {
          class: "btn-import",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (showImportModal.value = true))
        }, [
          _createVNode(_unref(FontAwesomeIcon), { icon: "file-import" }),
          _createTextVNode(" Import Events ")
        ]),
        _createElementVNode("button", {
          class: "btn-add",
          onClick: navigateToAddEvent
        }, [
          _createVNode(_unref(FontAwesomeIcon), { icon: "plus" }),
          _createTextVNode(" Add Event ")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("h1", null, "Events for " + _toDisplayString(calendarName.value), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("select", {
            id: "eventType",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.type) = $event))
          }, _hoisted_20, 512), [
            [_vModelSelect, filters.type]
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _withDirectives(_createElementVNode("input", {
            type: "date",
            id: "startDate",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.startDate) = $event)),
            max: filters.endDate
          }, null, 8, _hoisted_23), [
            [_vModelText, filters.startDate]
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _withDirectives(_createElementVNode("input", {
            type: "date",
            id: "endDate",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.endDate) = $event)),
            min: filters.startDate
          }, null, 8, _hoisted_26), [
            [_vModelText, filters.endDate]
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("button", {
            class: "btn-filter",
            onClick: applyFilters
          }, [
            _createVNode(_unref(FontAwesomeIcon), { icon: "filter" }),
            _createTextVNode(" Apply Filters ")
          ]),
          _createElementVNode("button", {
            class: "btn-reset",
            onClick: resetFilters
          }, [
            _createVNode(_unref(FontAwesomeIcon), { icon: "undo" }),
            _createTextVNode(" Reset ")
          ])
        ])
      ])
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(error.value), 1))
        : (viewMode.value === 'calendar')
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("button", {
                    class: "btn-nav",
                    onClick: previousMonth
                  }, [
                    _createVNode(_unref(FontAwesomeIcon), { icon: "chevron-left" })
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedMonth).value = $event)),
                      onChange: handleMonthChange,
                      class: "month-select"
                    }, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(months, (month, index) => {
                        return _createElementVNode("option", {
                          key: index,
                          value: index
                        }, _toDisplayString(month), 9, _hoisted_36)
                      }), 64))
                    ], 544), [
                      [_vModelSelect, selectedMonth.value]
                    ]),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedYear).value = $event)),
                      onChange: handleYearChange,
                      class: "year-select"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yearRange.value, (year) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: year,
                          value: year
                        }, _toDisplayString(year), 9, _hoisted_37))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, selectedYear.value]
                    ])
                  ]),
                  _createElementVNode("button", {
                    class: "btn-nav",
                    onClick: nextMonth
                  }, [
                    _createVNode(_unref(FontAwesomeIcon), { icon: "chevron-right" })
                  ])
                ]),
                _createElementVNode("button", {
                  class: "btn-today",
                  onClick: goToToday
                }, [
                  _createVNode(_unref(FontAwesomeIcon), { icon: "calendar-day" }),
                  _createTextVNode(" Today ")
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weekDays.value, (day) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: day,
                    class: "weekday"
                  }, _toDisplayString(day), 1))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_39, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calendarDays.value, (day) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: day.date.toISOString(),
                    class: _normalizeClass(["calendar-day", {
            'other-month': !day.isCurrentMonth,
            'has-events': day.events.length > 0,
            'school-closed': day.events.some(
              (event) => event.type === 'closed'
            ),
            'early-release': day.events.some(
              (event) => event.type === 'early_dismissal'
            ),
            today: isToday(day.date),
          }]),
                    onClick: ($event: any) => (handleDayClick(day))
                  }, [
                    _createElementVNode("div", _hoisted_41, _toDisplayString(day.dayNumber), 1),
                    (day.events.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          (day.events.some((event) => event.type === 'closed'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, " School Closed "))
                            : (
                day.events.some((event) => event.type === 'early_dismissal')
              )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_44, " Early Release "))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(day.events.slice(0, 2), (event) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: event.id,
                                      class: _normalizeClass(["event-dot", event.type || 'regular'])
                                    }, null, 2))
                                  }), 128)),
                                  (day.events.length > 2)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, " +" + _toDisplayString(day.events.length - 2), 1))
                                    : _createCommentVNode("", true)
                                ], 64))
                        ]))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_40))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_46, [
              _hoisted_47,
              _createElementVNode("div", _hoisted_48, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredEvents.value, (event) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: event.id,
                    class: "list-item"
                  }, [
                    _createElementVNode("div", _hoisted_49, _toDisplayString(event.title), 1),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["event-type-badge", event.type])
                      }, _toDisplayString(formatEventType(event.type)), 3)
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(event.gradeRanges || ['all_grades'], (range) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: range,
                          class: _normalizeClass(["grade-tag", range])
                        }, _toDisplayString(formatGradeRange(range)), 3))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _createTextVNode(_toDisplayString(formatDate(event.startDate)) + " ", 1),
                      (event.endDate && event.endDate !== event.startDate)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_53, " - " + _toDisplayString(formatDate(event.endDate)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("button", {
                        class: "btn-icon",
                        onClick: ($event: any) => (editEvent(event))
                      }, [
                        _createVNode(_unref(FontAwesomeIcon), { icon: "edit" })
                      ], 8, _hoisted_55),
                      _createElementVNode("button", {
                        class: "btn-icon",
                        onClick: ($event: any) => (confirmDelete(event))
                      }, [
                        _createVNode(_unref(FontAwesomeIcon), { icon: "trash" })
                      ], 8, _hoisted_56)
                    ])
                  ]))
                }), 128))
              ])
            ])),
    (showEventModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("h3", null, _toDisplayString(selectedDate.value ? "Add Event" : "Edit Event"), 1),
              _createElementVNode("button", {
                class: "btn-close",
                onClick: closeEventModal
              }, [
                _createVNode(_unref(FontAwesomeIcon), { icon: "times" })
              ])
            ]),
            (selectedEvent.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                  _createElementVNode("h4", null, _toDisplayString(selectedEvent.value.title), 1),
                  _createElementVNode("p", {
                    class: _normalizeClass(["event-type", selectedEvent.value.type])
                  }, _toDisplayString(formatEventType(selectedEvent.value.type)), 3),
                  _createElementVNode("p", _hoisted_61, [
                    _createTextVNode(_toDisplayString(formatDate(selectedEvent.value.startDate)) + " ", 1),
                    (
                selectedEvent.value.endDate &&
                selectedEvent.value.endDate !== selectedEvent.value.startDate
              )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_62, " - " + _toDisplayString(formatDate(selectedEvent.value.endDate)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (selectedEvent.value.description)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_63, _toDisplayString(selectedEvent.value.description), 1))
                    : _createCommentVNode("", true),
                  (selectedEvent.value.gradeRanges)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                        _hoisted_65,
                        _createElementVNode("div", _hoisted_66, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedEvent.value.gradeRanges, (range) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: range,
                              class: _normalizeClass(["grade-tag", range])
                            }, _toDisplayString(formatGradeRange(range)), 3))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_67, [
                  _createElementVNode("form", {
                    onSubmit: _withModifiers(submitNewEvent, ["prevent"])
                  }, [
                    _createElementVNode("div", _hoisted_68, [
                      _hoisted_69,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "title",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((newEvent.title) = $event)),
                        required: "",
                        placeholder: "Enter event title"
                      }, null, 512), [
                        [_vModelText, newEvent.title]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _hoisted_71,
                      _withDirectives(_createElementVNode("select", {
                        id: "type",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((newEvent.type) = $event)),
                        required: ""
                      }, _hoisted_82, 512), [
                        [_vModelSelect, newEvent.type]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_83, [
                      _hoisted_84,
                      _withDirectives(_createElementVNode("textarea", {
                        id: "description",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((newEvent.description) = $event)),
                        placeholder: "Enter event description",
                        rows: "3"
                      }, null, 512), [
                        [_vModelText, newEvent.description]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("div", _hoisted_86, [
                        _hoisted_87,
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          id: "startDate",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((newEvent.startDate) = $event)),
                          required: "",
                          min: calendarStartDate.value,
                          max: calendarEndDate.value
                        }, null, 8, _hoisted_88), [
                          [_vModelText, newEvent.startDate]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_89, [
                        _hoisted_90,
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          id: "endDate",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((newEvent.endDate) = $event)),
                          min: newEvent.startDate || calendarStartDate.value,
                          max: calendarEndDate.value
                        }, null, 8, _hoisted_91), [
                          [_vModelText, newEvent.endDate]
                        ]),
                        _hoisted_92
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_93, [
                      _createElementVNode("div", _hoisted_94, [
                        _hoisted_95,
                        _withDirectives(_createElementVNode("input", {
                          type: "time",
                          id: "startTime",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((newEvent.startTime) = $event))
                        }, null, 512), [
                          [_vModelText, newEvent.startTime]
                        ]),
                        _hoisted_96
                      ]),
                      _createElementVNode("div", _hoisted_97, [
                        _hoisted_98,
                        _withDirectives(_createElementVNode("input", {
                          type: "time",
                          id: "endTime",
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((newEvent.endTime) = $event))
                        }, null, 512), [
                          [_vModelText, newEvent.endTime]
                        ]),
                        _hoisted_99
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_100, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn-cancel",
                        onClick: closeEventModal
                      }, " Cancel "),
                      _createElementVNode("button", {
                        type: "submit",
                        class: "btn-submit",
                        disabled: isSubmitting.value
                      }, [
                        (isSubmitting.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_102, "Saving..."))
                          : (_openBlock(), _createElementBlock("span", _hoisted_103, "Save Event"))
                      ], 8, _hoisted_101)
                    ])
                  ], 32)
                ]))
          ])
        ]))
      : _createCommentVNode("", true),
    (showDeleteModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
          _createElementVNode("div", _hoisted_105, [
            _hoisted_106,
            _createElementVNode("p", null, " Are you sure you want to delete the event \"" + _toDisplayString(eventToDelete.value?.title) + "\"? ", 1),
            _hoisted_107,
            _createElementVNode("div", _hoisted_108, [
              _createElementVNode("button", {
                class: "btn-cancel",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (showDeleteModal.value = false))
              }, " Cancel "),
              _createElementVNode("button", {
                class: "btn-confirm-delete",
                onClick: deleteEvent
              }, " Delete ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showImportModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
          _createElementVNode("div", _hoisted_110, [
            _createElementVNode("div", _hoisted_111, [
              _hoisted_112,
              _createElementVNode("button", {
                class: "btn-close",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (showImportModal.value = false))
              }, [
                _createVNode(_unref(FontAwesomeIcon), { icon: "times" })
              ])
            ]),
            _createVNode(ImportICSEvents, {
              "calendar-id": Number(_unref(calendarId)),
              onClose: _cache[17] || (_cache[17] = ($event: any) => (showImportModal.value = false)),
              onImportComplete: fetchCalendar
            }, null, 8, ["calendar-id"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})